import { Icon, IconProps } from '../types';

const name = 'circle';

export function getCircle(props: Partial<IconProps>): Icon {
  const { color } = props;
  const contents = `<circle cx="31" cy="41" r="29" ${color ? `fill="${color}"` : ''} />`;
  return {
    name,
    contents,
  };
}

const icon: Icon = getCircle({});
export default icon;
